module.exports = __webpack_public_path__ + "img/dispositivo inhalador polvo.25e16992.png";